export default "__VITE_ASSET__593WQwuF__"